import React from "react";
import { BsBellFill } from "react-icons/bs";
import { NotificationContainer } from "./Notification.Style";

const Notification: React.FC = () => {
  return (
    <NotificationContainer>
      <div className="notification">Notification</div>
      <div className="notification-section">
        <div className="bellOuter">
          <div>
            <BsBellFill size={50} color="white" />
          </div>
        </div>
        <div>No Notification yet!</div>
        <div style={{ color: "#6c757d" }}>
          You will be notified when something arrives!
        </div>
      </div>
    </NotificationContainer>
  );
};

export default Notification;
